import React from 'react'

interface TextFieldProps {
  id: string
  type: string
  placeholder: string
  label?: string
  value?: string
  maxLength?: number
  softLimit?: number
  showCounter?: boolean
  setValue: (value: string) => void
}

const TextField = ({ id, type, placeholder, label, value, maxLength, softLimit, showCounter = false, setValue }: TextFieldProps): JSX.Element => {
  const currentLength = value?.length ?? 0
  const displayLimit = softLimit ?? maxLength
  const isOverSoftLimit = softLimit !== undefined && currentLength > softLimit

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-600 mb-1">
          {label}
        </label>
      )}
      <input
        className="block w-full p-4 text-sm rounded-lg bg-gray-50 border border-gray-200 focus:border-none focus:outline focus:outline-2 focus:outline-teal-500"
        type={type}
        id={id}
        placeholder={placeholder}
        maxLength={maxLength}
        value={value}
        onChange={(evt: React.ChangeEvent<HTMLInputElement>) => { setValue(evt.target.value) }}
      />
      {showCounter && displayLimit && (
        <div className="flex justify-end mt-1">
          <span className={`text-xs ${isOverSoftLimit ? 'text-amber-500 font-medium' : 'text-gray-400'}`}>
            {currentLength}/{displayLimit}
          </span>
        </div>
      )}
    </div>
  )
}

export default TextField
